import { createSlice } from "@reduxjs/toolkit";

import { ProfileSlice } from "./types";

export const initialState: ProfileSlice = {
  userProfile: undefined,
  // activeRole: undefined,
  // privileges: [],
  userPictureUrl: undefined,
  userProfileRole: undefined,
};

export const profileSlice = createSlice({
  name: "profileSlice",
  initialState,
  reducers: {
    setProfile: (state, action) => ({
      ...state,
      userProfile: action.payload,
    }),
    setProfilePictureBase64: (state, action) => ({
      ...state,
      userPictureUrl: action.payload,
    }),
    setProfileRole: (state, action) => ({
      ...state,
      userProfileRole: action.payload,
    }),
  },
});

export const { setProfile, setProfilePictureBase64, setProfileRole } =
  profileSlice.actions;
export const profileReducer = profileSlice.reducer;
